import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import InputGroup from 'react-bootstrap/InputGroup'
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { DisplaySavedMessage } from './DisplaySavedMessage'
import { AddRuralReturn } from './AddRuralReturn';
import { useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Placeholder from 'react-bootstrap/Placeholder';
import { GetAccessToken } from "../index";
import { useMsal } from "@azure/msal-react";
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Toast from 'react-bootstrap/Toast';
import "./AddResidentialReturn.css";
import Checkbox from "@mui/material/Checkbox";
import { msalConfig } from '../authConfig';
import { useAppConfig } from '../config/AppConfigContext';


export function EditResidentialReturn({...props }) {
    const { instance } = useMsal();
    const [showRural, setShowRural] = useState(false);
    const [message, setMessage] = useState(null);
    const [validated, setValidated] = useState(false);
    const [validationError, setValidationError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);
    const handleCloseModalDelete = () => setShowModalDelete(false);
    const [data, setData] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [isAddressVisible, setAddressIsVisible] = useState(false);
    const [SelectedDateRange, setDateRangeValue] = useState([]);
    const [SelectedCategory, setReturnListCategory] = useState([]);
    const [SelectedReturnStatus, setReturnListStatus] = useState([]);
    const [SelectedReturnSaleMethod, setReturnListSaleMethod] = useState([]);
    const [errorMessage, seterrorMessage] = useState('');
    const [error, setError] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const handleClose = () => setShowModal(false);
    const [isOrgVisible, setOrgIsVisible] = useState(false);
    const [isOrgsVisible, setOrgsIsVisible] = useState(false);
    const [searchOrgResults, setOrgSearchResults] = useState([]);
    const [searchOrgsResults, setOrgsSearchResults] = useState([]);
    const [isAgencyVisible, setAgencyIsVisible] = useState(false);
    const [searchAgencyResults, setAgencySearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [residential, setresidential] = useState({
        SaleId: null,
        DbId:null,
        OfficeReinzId: null,
        ReturnType: "Residential",
        SaleIsConjoint: false,
        ConjointOfficeReinzId: null,
        AdminNotes: null,
        ReturnPeriod: (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear(),
        ExternalId: null,
        AddressSearch: null,
        ValRef: null,
        Unit: null,
        Suffix: null,
        StreetNumber:null,
        Street: null,
        Suburb: null,
        PostalCode:0,
        Category: null,
        /*Title:"",*/
        FreeholdStatus: null,
        FloorArea: null,
        LandArea: null,
        //Land:null,
        //FloorAreaSelect:"1",
        Bedrooms: 0,
        Bathrooms: 0,
        ParkingTotal: null,
        IsNewDwelling: false,
        IsSaleAsIs: false,
        IsOwnerOccupied: false,
        IsFirstHomeBuyer: false,
        IsMortgageSale: false,
        IsInvestmentOrRental: false,
        Held: false,
        Suppressed: false,
        HasPool: false,
        IsGstExempt: false,
        DepositSaleOnly: false,
        SaleMethod: null,
        ListPrice: 0,
        SalePrice: null,
        ListDate: '',
        AgreementDate: '',
        UnconditionalDate: '',
        SettlementDate:null,
        Valuation: 0,
        ValuationDate:'',
        LandValue: 0,
        ValuationImprovement: 0,
        //fields used by API's but not by forms
        Latitude:null,
        Longitude:null,
        LinzTlaId: null,
        TlaId: null,
        CertificateOfTitle: null,
        TownCity: null,
        LandClass: null,
        Created:null
    });
    const newresidential = { ...residential }
    const [isVisibleTopButton, setIsVisibleTopButton] = useState(false);
    const listDateObj = new Date(residential.ListDate);
    const agreementDateObj = new Date(residential.AgreementDate);
    var orgEntered = "";
    const config = useAppConfig();
    useEffect(() => {
        const fetchReturnsList = async () => {
            //console.log("profile");
            const url = "api/ReturnList/GetReturnLists";
            const tokenRequest = {
                scopes: config.apiScopes,
                account: instance.getActiveAccount()
            };
            const accessToken = await GetAccessToken(tokenRequest);

            try {
                await fetch(url,
                    {
                        method: "POST",
                        headers: new Headers(
                            {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${accessToken}`
                            }),
                        body: JSON.stringify({ fromDate: SelectedDateRange[0], toDate: SelectedDateRange[1], SelectedCategory: SelectedCategory, SelectedReturnStatus: SelectedReturnStatus, SelectedReturnSaleMethod: SelectedReturnSaleMethod })
                    })
                    .then((response) => {
                        console.log(response, 'response');
                        if (response.status !== 200 && response.status !== 201) {
                            console.log("not ok" + response.status);
                        }
                        else {
                            return response.json()
                        }
                    })
                    .then(data => {
                        console.log(data)
                        if (data !== null && data !== undefined) {
                            const newdata = data.find(x => x.saleId === props.saleId);
                            newresidential.SaleId = newdata.datamineSaleId;
                            newresidential.DbId = newdata.saleId;
                            newresidential.OfficeReinzId = newdata.organisationName;
                            newresidential.ReturnType = newdata.saleType;
                            newresidential.SaleIsConjoint = newdata.SaleIsConjoint;
                            newresidential.ConjointOfficeReinzId = newdata.participantOfficeReinzIds;
                            newresidential.AddressSearch = newdata.fullAddress;
                            newresidential.ExternalId = newdata.externalId;
                            newresidential.AdminNotes = newdata.adminNotes;
                            newresidential.ReturnPeriod = newdata.unconditionalDate !== null ? (newdata.unconditionalDate).slice(0, 10) : null;
                            newresidential.ValRef = newdata.valRef;
                            newresidential.Unit = newdata.unit;
                            newresidential.Suffix = newdata.suffix !== null ? newdata.suffix:""; 
                            newresidential.StreetNumber = newdata.streetNumber; 
                            newresidential.Street = newdata.street;
                            newresidential.Suburb = newdata.suburb;
                            newresidential.PostalCode = newdata.postalCode;
                            newresidential.Category = newdata.saleCategory;
                            newresidential.FreeholdStatus = newdata.freeholdStatus;

                            newresidential.FloorArea = newdata.floorArea;
                            newresidential.LandArea = String(newdata.landArea).replace(/sqm$/, "").trim();
                            //newresidential.LandArea = newdata.landArea.replace(/[^\d.-]/g, '');// Extract numeric part
                            //newresidential.FloorAreaSelect = newdata.landArea.includes('Ha') ? '2' : '1'; 
                            newresidential.Bedrooms = newdata.bedrooms;
                            newresidential.Bathrooms = newdata.bathrooms;
                            newresidential.ParkingTotal = newdata.parkingTotal;
                            newresidential.IsNewDwelling = newdata.newDwelling;
                            newresidential.IsSaleAsIs = newdata.saleAsIs;
                            newresidential.IsOwnerOccupied = newdata.ownerOccupied;
                            newresidential.IsFirstHomeBuyer= newdata.firstHomeBuyer;
                            newresidential.IsMortgageSale = newdata.mortgageSale;

                            newresidential.IsInvestmentOrRental = newdata.investmentOrRental;
                            newresidential.Held= newdata.held;
                            newresidential.Suppressed = newdata.suppressed;
                            newresidential.HasPool = newdata.hasPool;
                            newresidential.IsGstExempt = newdata.gstExempt;
                            newresidential.DepositSaleOnly = false;

                            newresidential.SaleMethod = newdata.saleMethod;
                            newresidential.ListPrice = newdata.listPrice;
                            newresidential.SalePrice = newdata.salePrice;
                            newresidential.ListDate = newdata.listDate !== null ? (newdata.listDate).slice(0, 10) : null;
                            newresidential.AgreementDate = newdata.agreementDate !== null ? (newdata.agreementDate).slice(0, 10) :null;
                            newresidential.UnconditionalDate = newdata.unconditionalDate !== null ? (newdata.unconditionalDate).slice(0, 10) : null;
                            newresidential.SettlementDate = newdata.settlementDate !== null ? (newdata.settlementDate).slice(0, 10) : null;
                            newresidential.Valuation = newdata.valuation;
                            newresidential.ValuationDate = newdata.valuationDate !== null ? (newdata.valuationDate).slice(0, 10) : null;
                            newresidential.LandValue = newdata.landValue;
                            newresidential.ValuationImprovement = newdata.valuationImprovement;
                            newresidential.SaleIsConjoint = newdata.saleIsConjoint;
                            //fields used by API's but not by forms
                            newresidential.Latitude = newdata.latitude !== null ? newdata.latitude : null;
                            newresidential.Longitude = newdata.longitude !== null? newdata.longitude : null;
                            newresidential.LinzTlaId = 0;
                            newresidential.TlaId = newdata.tlaId;
                            newresidential.CertificateOfTitle = newdata.certificateOfTitle;
                            newresidential.TownCity = newdata.townCity;
                            newresidential.LandClass = newdata.landClass;
                            newresidential.Created = newdata.created.slice(0, 10);
                            setresidential(newresidential);
                            
                        }
                        console.log(residential);
                    })
                    //setIsLoading(false)
                    .catch(error => {
                        console.error('Error:', error);
                    });
            }
            catch (error) {
                if (error.response) {
                    console.log(error);
                }
            }
        }
        fetchReturnsList();
    }, [])

    // Scroll event listener to show/hide the button
    useEffect(() => {
        const handleScroll = () => {
            console.log('window.scrollY:', window.scrollY);
            console.log('document.documentElement.scrollTop:', document.documentElement.scrollTop);

            if (window.scrollY > 900 || document.documentElement.scrollTop > 900) {
                setIsVisibleTopButton(true);
            } else {
                setIsVisibleTopButton(false);
            }
        };
        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const isClicked = () => {
        setShowRural(() => !showRural);
        handleClose();
    }

    const [showLastMonths] = useState([
        {
            key: 1,
            value: (new Date((new Date()).setMonth((new Date()).getMonth()))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth()))).getFullYear()
        },
        {
            key: 2,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 1))).getFullYear()
        },
        {
            key: 3,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 2))).getFullYear()
        },
        {
            key: 4,
            value: (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getMonth() + 1 + '/' + (new Date((new Date()).setMonth((new Date()).getMonth() - 3))).getFullYear()
        }
    ]);

    function handle(e) {
        const newresidential = { ...residential }
        const { id, value, type } = e.target;
        // Convert numeric inputs to numbers
        if (type === "number") {
            newresidential[id] = value === '' ? '' : Number(value);
        }
        // Default: just assign the string value
        else {
            newresidential[id] = value;
        }
            //newresidential[e.target.id] = e.target.value;
            console.log(residential);
            setresidential(newresidential);
    }
    
    function checkboxHandle(e) {
        const { name, value, checked, type } = e.target;
        setresidential
            (
                prevData =>
                ({
                    ...prevData,
                    [name]: type ===
                        'checkbox' ? checked : value
                }));
    }
    var addressEntered = "";
    function handleAddressSearch(e) {
        const { id } = e.target;
        addressEntered = e.target.value;
        setresidential((prev) => ({
            ...prev,
            AddressSearch: addressEntered
        }));
        //setSelectedAddress(addressEntered);
        setAddressIsVisible(true);
        if (addressEntered.length >= 6) {
            handleAddress();
        }
    }
    const handleAddress = async () => {
        const url = "api/address/GetAddress";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
                body: JSON.stringify(addressEntered)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                    setSearchResults(data);
                    }
                })
                .catch(error => {
                    console.error('Error fetching addresses', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }

    }

    // Scroll to the top function
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    //Submit delete request
    const sale = {
        saleId: props.saleId
    };
    const SubmitDelete = async (e) => {
        /*e.preventDefault();*/
        setShowModalDelete(false);
        //alert("Hello1");

        const url = "api/DeleteReturn/DeleteReturn/?id=" + props.saleId;
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            fetch(url,
                {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(sale),
                })
                .then((response) => {
                    //console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        //console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    setData(data)
                    //console.log(data)
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    //
    const handleDeleteSaleAlert = () => {
        setData(false);
        props.onGoBack();
        alert("Return Deleted");
        
    };
    //Edit/Update a return
    const SubmitUpdate = async (e) => {
        e.preventDefault();
        //scrollTop();
        //alert("Hello1");
        const form = document.getElementById('AddResidentialReturnForm');
        if (!form.checkValidity()) {
            e.stopPropagation();
            setValidated(true);
            seterrorMessage(true);
            setValidationError('Please fill in all required fields.');
            setError('Please fill in all required fields.');
            return; // Prevent submission if invalid
        }
        setValidated(true);
        setError(null);
        setValidationError(null);
        seterrorMessage(false);

        const url = "api/ResidentialReturn/UpdateResidentialReturn/?id="+props.saleId;
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        try {
            setLoading(true);
            const accessToken = await GetAccessToken(tokenRequest);
            //fetch
            const response=await fetch(url,
                {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(residential),

                });
            if (!response.ok) {
                console.log("not ok" + response.status);
                throw new Error('Network response was not ok');
            }
            else {
                const data = await response.json();
                setShowToast(true);
                setLoading(false);
                /*setMessage(true);*/
                //setMessage('Sale updated successfully');
                //seterrorMessage(false);
                //setresidential(initialResidentialState); // Resetting state
                //setTimeout(() => {
                //    setMessage(false);
                //}, 5000);
            }
        }
        catch (error) {
            console.log(error);
            setLoading(false);
            seterrorMessage(true);
            setMessage('Error saving data. Please try again.');
            setTimeout(() => {
                setMessage(false);
            }, 5000);
        }
    }
    function handleConjointOfficesSearch(e) {
        const { id } = e.target;
        orgEntered = e.target.value;
        setresidential((prev) => ({
            ...prev,
            ConjointOfficeReinzId: orgEntered
        }));
        setOrgIsVisible(true);
        /*setSelectedOrg(orgEntered);*/
        if (orgEntered.length >= 4) {
            handleConjointOffices();
        }
    }
    function handleOfficeSearch(e) {
        const { id } = e.target;
        orgEntered = e.target.value;
        setresidential((prev) => ({
            ...prev,
            OfficeReinzId: orgEntered
        }));
        setAgencyIsVisible(true);
        if (orgEntered.length >= 4) {
            handleConjointOffices();
        }
    }
    const handleSelectAgency = (agency) => {
        setresidential((prevData) => ({ ...prevData, OfficeReinzId: agency }));
        setAgencyIsVisible(false);
    };
    const handleConjointOffices = async () => {
        const url = "api/organisation/GetOrganisation";
        const tokenRequest = {
            scopes: config.apiScopes,
            account: instance.getActiveAccount()
        };
        const accessToken = await GetAccessToken(tokenRequest);
        try {
            fetch(url, {
                method: "POST",
                headers: new Headers({
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                }),
                body: JSON.stringify(orgEntered)
            })
                .then((response) => {
                    console.log(response, 'response');
                    if (response.status !== 200 && response.status !== 201) {
                        console.log("not ok" + response.status);
                    }
                    else {
                        return response.json()
                    }
                }).then(data => {
                    console.log(data)
                    if (data !== null && data !== undefined) {
                        setOrgSearchResults(data);
                        setAgencySearchResults(data);
                        //setOrgIsVisible(true);
                    }
                })
                .catch(error => {
                    console.error('Error fetching organisations', error);
                });
        }
        catch (error) {
            if (error.response) {
                console.log(error);
            }
        }
    }
    const handleSelectAddress = (address) => {
        //old source code not recommended
        //setIsVisible(false);
        //newresidential.ValRef = address.valRef;
        //newresidential.AddressSearch = address.addressSearch;
        //newresidential.Unit = address.unit;
        //newresidential.Suffix = address.suffix;
        //newresidential.StreetNumber = address.streetNumber.toString();
        //newresidential.Street = address.street;
        //newresidential.Suburb = address.suburbName;
        //newresidential.TownCity = address.townCity;
        //newresidential.PostalCode = address.postcode;
        //newresidential.LandValue = address.landValue;
        //newresidential.Longitude = address.longitude;
        //newresidential.Latitude = address.latitude;
        //newresidential.Valuation = address.councilValuation;
        //newresidential.Bathrooms = address.bathrooms;
        //newresidential.Bedrooms = address.bedrooms;
        //newresidential.FloorArea = address.floorArea;
        //newresidential.LandArea = address.landArea;
        //newresidential.ValuationImprovement = address.improvementValue;
        //newresidential.CertificateOfTitle = address.certificateOfTitle;
        //setresidential(newresidential);

        //new source code
        const updatedResidential = {
            ...newresidential, // or use the current residential state if needed
            ValRef: address.valRef,
            AddressSearch: address.addressSearch,
            Unit: address.unit,
            Suffix: address.suffix,
            StreetNumber: address.streetNumber.toString(),
            Street: address.street,
            Suburb: address.suburbName,
            TownCity: address.townCity,
            PostalCode: address.postcode,
            LandValue: address.landValue,
            Longitude: address.longitude,
            Latitude: address.latitude,
            Valuation: address.councilValuation,
            Bathrooms: address.bathrooms,
            Bedrooms: address.bedrooms,
            FloorArea: address.floorArea,
            LandArea: address.landArea,
            ValuationImprovement: address.improvementValue,
            CertificateOfTitle: address.certificateOfTitle,
            FreeholdStatus: address.freeholdStatus,
            Category:address.propertyCategory
        };

        setresidential(updatedResidential);
        setAddressIsVisible(false); // Hide the suggestion list after selection
    };
    const handleSelectOrg = (org) => {
        if (org && !searchOrgsResults.includes(org.trim())) {
            setOrgsSearchResults((searchOrgsResults) => {
                const updatedOrgsList = [...searchOrgsResults, org.trim()]
                // Update state
                setresidential((prevData) => ({ ...prevData, ConjointOfficeReinzId: org }));
                /*setOrgSearchResults(['']);*/
                return updatedOrgsList;// Return the updated list for the state
            });
        }
        setOrgIsVisible(false);
        /*setOrgsIsVisible(true);*/
    };

    const handleRemoveSearchTerm = (org) => {
        setOrgsSearchResults((searchOrgsResults) => {
            const updatedOrgsList = searchOrgsResults.filter((searchorg) => searchorg !== org)
            //const updatedResidential = {
            //    ...newresidential,
            //    ConjointOfficeReinzId: updatedOrgsList
            //};
            //// Update state
            //setresidential(updatedResidential);

            // Only update residential if you're removing the currently selected one
            setresidential((prev) => ({
                ...prev,
                ConjointOfficeReinzId: updatedOrgsList.includes(prev.ConjointOfficeReinzId) ? prev.ConjointOfficeReinzId : ''
            }));
            return updatedOrgsList;// Return the updated list for the state
        });
    }

    const renderTooltip_returntype = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Changing this to a Rural Return will remove all residential specific fields
        </Tooltip>
    );

    const renderTooltip_saleisconjoint = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Marking a sale as conjoint will allow REINZ to match this sale with returns submitted by participating offices
        </Tooltip>
    );

    const renderTooltip_returnperiod = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Return Period will be determined by the date entered in the Unconditional Date field below
        </Tooltip>
    );

    const renderTooltip_externalid = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            If your agency requires your return to contain an ID for reporting purposes, enter it here
        </Tooltip>
    );

    const renderTooltip_addresssearch = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Selecting an address with this search box will overwrite any changes you've made to this form
        </Tooltip>
    );

    const renderTooltip_saleasis = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            In real estate, 'sale as is' denotes selling of a property without guarantees or warranties about its condition, often seen in cases of natural disasters or significant events.
        </Tooltip>
    );
    const renderTooltip_listdate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            The date which agency signed agreement with vendor to list property.
        </Tooltip>
    );

    const renderTooltip_agreementdate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            The date which sale and purchase agreement was signed.
        </Tooltip>
    );

    const renderTooltip_holdsale = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Holding a sale will prevent it being searchable in the unconditional sale month.
            Holding a sale will not enable real time sales searching for your agency.
        </Tooltip>
    );

    const renderTooltip_supresssale = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Supressing a sale prevents it being searchable until the sale has settled or 6 months.
            Supressing sales is actively monitored by REINZ and you will be asked the reason why it has supressed.
            Supressing should only be done for legal privacy reasons.
        </Tooltip>
    );

    const renderTooltip_unconditionaldate = (props) => (
        <Tooltip  {...props} className="tooltipColor">
            Unconditional Date will be used to determine which Return Period this return will be submitted under.
        </Tooltip>
    );

    return (
        <>
            <Modal size="lg" show={showModal} onHide={handleClose} animation={false} className="dark-mode-modal">
                <Modal.Header closeButton>
                <Modal.Title>Are you sure you want to change this return from residential to a rural return?</Modal.Title>
                </Modal.Header>
                <Modal.Body>This will remove all residential data from the return form</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                Cancel
                </Button>
                <Button style={{ backgroundColor: "#331b8c" }} onClick={isClicked}>
                Confirm
                </Button>
                </Modal.Footer>
            </Modal>

            {data === true && handleDeleteSaleAlert()}
            <Modal size="lg" show={showModalDelete} onHide={handleCloseModalDelete} animation={false} className="dark-mode-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Are you sure you want to delete this return?</Modal.Title>
                </Modal.Header>
                <Modal.Body>This return will be deleted immediatly and you will be returned to the Returns List page</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalDelete}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: "#331b8c" }} onClick={() => SubmitDelete()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {showRural ? <AddRuralReturn {...residential} /> :
                <>
                    <div className="container" id="AddResidentialReturn">
                        <h1>Update a Residential Return</h1>
                        <Button style={{ backgroundColor: "#331b8c", border: 'none' }} size="sm" onClick={props.onGoBack}>
                            <i className="bi bi-arrow-left-square"></i>&nbsp;Back
                        </Button><br />
                        <Button style={{ backgroundColor: "#331b8c", border: 'none', float: 'right' }} id="Delete" size="sm" onClick={() => {
                            setShowModalDelete(true)
                        }}><i className="bi bi-trash3-fill"></i>&nbsp;Delete</Button>

                        {isVisibleTopButton && (
                            <Button onClick={scrollTop} id="GoToTop" title="Go to top">
                                <i className="fas fa-arrow-up" style={{ fontSize: '20px' }}></i>
                            </Button>
                        )}
                        <form id="AddResidentialReturnForm" noValidate validated={validated}>
                            {/*{message === true && <DisplaySavedMessage />} */}
                            {message && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{message}</div>}
                            {validationError && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{validationError}</div>}
                            <Toast
                                show={showToast}
                                style={{
                                    position: 'fixed',
                                    top: '25%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 9999,
                                    minWidth: '300px',
                                    textAlign: 'center',
                                    backgroundColor: '#f8f9fa', // Optional: Light background
                                    border: '1px solid #28a745'
                                }}
                                onClose={() => setShowToast(false)}>
                                <Toast.Header style={{
                                    color: 'green',
                                    fontWeight: 'bold',
                                    fontSize: '1.2rem'} }>
                                    <strong className="me-auto">Sale updated successfully!</strong>
                                </Toast.Header>
                            </Toast>
                            <h4 style={{ color: "#ffffff" }}>Primary Property Information</h4> 
                            
                            <div className="form-group">
                                <label className="labelClass" htmlFor="CompanyInput">Company <span style={{ color: 'red' }}>*</span></label>
                                {/*<label required>{residential.OfficeReinzId}</label>*/}
                                <input type='text' className="form-control" id="OfficeReinzId" placeholder="Start typing to search through Agencies"
                                    value={residential.OfficeReinzId || ''} onChange={(e) => handleOfficeSearch(e)} required></input>
                                {(residential.OfficeReinzId === null || residential.OfficeReinzId==='') &&
                                    //<label as="label" className="required" style={{ color: 'red' }}>
                                    //    Company is required
                                    //</label>
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                                {isAgencyVisible &&
                                    <ul id="OfficeReinzId" className="List">
                                        {searchAgencyResults.map((agency, index) => (
                                            <li key={index} onClick={() => handleSelectAgency(agency)}>
                                                {agency}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="ReturnTypeInput" id="ReturnType" value={residential.ReturnType}>Return Type<OverlayTrigger
                                    placement="top" overlay={renderTooltip_returntype}><sup>?</sup></OverlayTrigger>
                                </label>
                                <label value={residential.ReturnType}>Residential&nbsp;&nbsp;</label>
                                <button className="btnClass" onClick={(e) => { setShowModal(true); e.preventDefault() }} >
                                    <i className="bi bi-arrow-repeat iconStyles" style={{ marginRight: "8px" }}></i>
                                    Change Return Type
                                </button>
                            </div>
                            <div className="form-group" id="CheckboxClass">
                                <label className="labelClass" htmlFor="SaleIsConjointInput">Sale Is Conjoint<OverlayTrigger
                                    placement="top" overlay={renderTooltip_saleisconjoint}><sup>?</sup></OverlayTrigger>
                                </label>
                                <Checkbox id="SaleIsConjoint" name="SaleIsConjoint"
                                    checked={residential.SaleIsConjoint}
                                    onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="ConjointCompaniesInput">Conjoint Companies</label>
                                <div className="input-group">
                                    <span class="input-group-text" id="dollar-sign" >
                                        <i class="bi bi-search iconStyles"></i>
                                    </span>
                                    <input type="text" className="form-control" id="ConjointOfficeReinzId" placeholder="Start typing to search through Agencies"
                                        value={residential.ConjointOfficeReinzId || null} onChange={(e) => handleConjointOfficesSearch(e)} />
                                </div>
                                {isOrgVisible &&
                                    <ul id="ConjointOfficeReinzId" className="List">
                                        {searchOrgResults.map((org, index) => (
                                            <li key={index} onClick={() => handleSelectOrg(org)}>
                                                {org}
                                            </li>
                                        ))}
                                    </ul>
                                }
                                {isOrgsVisible &&
                                    <ul id="ConjointOfficeReinzId" className="List">
                                        {searchOrgsResults.map((org, index) => (
                                            <li key={index}>
                                                <button id="button" onClick={() => handleRemoveSearchTerm(org)}><i className="bi bi-trash3-fill"></i>&nbsp;Remove</button>&nbsp;&nbsp;&nbsp;
                                                <span>{org}</span>

                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className="form-group">
                                <label className="labelClass" htmlFor="REINZAdminNotesInput">REINZ Admin Notes</label>
                                <textarea id="AdminNotes" className="form-control" rows="2" value={residential.AdminNotes || null} onChange={(e) => handle(e)}></textarea>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ReturnPeriodInput">Return Period<OverlayTrigger placement="top"
                                    overlay={renderTooltip_returnperiod}><sup>?</sup></OverlayTrigger>
                                </label>
                                <div id="SelectStyle">
                                    <select name="ReturnPeriod" className="form-control">
                                        value={residential.ReturnPeriod}
                                        onChange={(e) => handle(e)}
                                        {showLastMonths.map((info) => (
                                            <option className="form-control" key={info.key} value={info.value}>{info.value}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="ExternalIDInput">External ID<OverlayTrigger
                                    placement="top" overlay={renderTooltip_externalid}><sup>?</sup></OverlayTrigger>
                                </label>
                                <input type="text" className="form-control" id="ExternalId" value={residential.ExternalId || null} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="AddressSearchInput">Address Search<OverlayTrigger placement="top"
                                    overlay={renderTooltip_addresssearch}><sup>?</sup></OverlayTrigger>
                                </label>
                                <div className="input-group">
                                    <span class="input-group-text" id="dollar-sign" >
                                        <i class="bi bi-search iconStyles"></i>
                                    </span>
                                    <input type="text" autoComplete="street-address" className="form-control" id="AddressSearch" name="AddressSearch" value={residential.AddressSearch || null}
                                        onChange={(e) => handleAddressSearch(e)} placeholder="Start typing to search through addresses" minLength={6} />
                                </div>
                                {/*{selectedAddress === null &&*/}
                                {/*    <p style={{ color: "#ffffff", fontSize: "1rem" }}>Selecting an address with this search box will overwrite any changes you've made to this form</p>*/}
                                {/*}*/}
                                {isAddressVisible &&
                                    <ul id="addressSearch" className="List">
                                        {searchResults.map((address) => (
                                            <li key={address.id} onClick={() => handleSelectAddress(address)} style={{ color: "#ffffff" }}>
                                                {address.addressSearch}
                                            </li>
                                        ))}
                                    </ul>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="ValRefInput">Val Ref</label>
                                <input type="text" className="form-control" id="ValRef" value={residential.ValRef || null} onChange={(e) => handle(e)} placeholder="Example 22900/42602" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="UnitInput">Unit Number</label>
                                <input type="text" className="form-control" id="Unit" value={residential.Unit || null} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="SuffixInput">Suffix</label>
                                <input type="text" className="form-control" id="Suffix" value={residential.Suffix || null} onChange={(e) => handle(e)} placeholder="Example A" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="StreetNumberInput">Street Number <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="StreetNumber" value={residential.StreetNumber || null} onChange={(e) => handle(e)} required />
                                {(residential.StreetNumber === null || residential.StreetNumber === '') &&
                                    /*<label as="label" style={{ color: 'red' }} className="required">Street Number is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="StreetInput">Street Name <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="Street" value={residential.Street || null} onChange={(e) => handle(e)} required />
                                {(residential.Street === null || residential.Street === '') &&
                                    /*<label as="label" style={{ color: 'red' }} className="required" value="street_name">Street Name is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="SuburbInput">Suburb <span style={{ color: 'red' }}>*</span></label>
                                <input type="text" className="form-control" id="suburbName" value={residential.Suburb || null} onChange={(e) => handle(e)} required minLength={4}
                                    placeholder="Start typing to search through suburbs" />
                                {(residential.Suburb ===null || residential.Suburb === '') &&
                                    /*<label as="label" style={{ color: 'red' }} className="required">Suburb is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }                                
                            </div>
                            <div className="form-group">
                                <label htmlFor="PostalCodeInput">Post Code</label>
                                <input type="number" className="form-control" id="PostalCode" value={(residential.PostalCode).toString().padStart(4,"0")} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="CategoryInput">Property Category <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="Category" className="form-control" id="Category" value={residential.Category || null} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Residence">Residence</option>
                                        <option className="form-control" value="Residential Section">Residential Section</option>
                                        <option className="form-control" value="Unit">Unit</option>
                                        <option className="form-control" value="Apartment">Apartment</option>
                                        <option className="form-control" value="Townhouse">Townhouse</option>
                                        <option className="form-control" value="Home and Income">Home and Income</option>
                                        <option className="form-control" value="Residential Investment Block">Residential Investment Block</option>
                                        <option className="form-control" value="Residential- Other">Residential- Other</option>
                                    </select>
                                </div>
                                {(residential.Category === null || residential.Category === '') &&
                                    /* <label as="label" className="required" style={{ color: 'red' }}>Property Category is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            {residential.Category === 'Residential Investment Block' &&
                                <label as="label" className="required" style={{ color: 'red' }}>residential_type set as RIB</label>}<br />
                            <div className="form-group">
                                <label htmlFor="CertificateOfTitleInput">Title</label>
                                <input type="text" className="form-control" id="CertificateOfTitle" value={residential.CertificateOfTitle || null} onChange={(e) => handle(e)} />
                            </div>
                            {/*Latitude*/}
                            <div style={{ display: "none" }}>
                                <label column>Latitude</label>
                                <input type="text" className="form-control" id="Latitude" value={residential.Latitude || null} onChange={(e) => handle(e)} />
                            </div>
                            {/*Longitude*/}
                            <div style={{ display: "none" }}>
                                <label column>Longitude</label>
                                <input type="text" className="form-control" id="Longitude" value={residential.Longitude || null} onChange={(e) => handle(e)} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="FreeholdStatusInput">Freehold Status <span style={{ color: 'red' }}>*</span></label>
                                <div id="SelectStyle">
                                    <select name="FreeholdStatus" className="form-control" id="FreeholdStatus" value={residential.FreeholdStatus || null} onChange={(e) => handle(e)} required>
                                        <option className="form-control"></option>
                                        <option className="form-control" value="Unknown">Unknown</option>
                                        <option className="form-control" value="Freehold">Freehold</option>
                                        <option className="form-control" value="Leasehold">Leasehold</option>
                                        <option className="form-control" value="Crosslease">Crosslease</option>
                                        <option className="form-control" value="UnitTitle">Unit Title</option>
                                        <option className="form-control" value="Company">Company</option>
                                        <option className="form-control" value="Strata">Strata</option>
                                    </select>
                                </div>
                                {(residential.FreeholdStatus === null || residential.FreeholdStatus === '') &&
                                    /*<label as="label" className="required" style={{ color: 'red' }}>Freehold Status is required</label>*/
                                    <div style={{ color: 'red' }}>{error}</div>
                                }
                            </div>
                            {/*Residential Information*/}
                            <h4 style={{ color: "#ffffff" }}>Residential Information</h4>
                            <div className="form-group">
                                <label htmlFor="FloorAreaInput">Floor Area</label>
                                <div className="input-group">
                                    <input type="number" className="form-control" id="FloorArea" value={residential.FloorArea || 0} onChange={(e) => handle(e)} required />
                                    <select className="form-control" id="FloorAreaSelect" value={"1"}>
                                        <option className="form-control" value="1"><sub>m</sub>2</option>
                                        <option className="form-control" value="2">Ha</option>
                                    </select>
                                </div>
                                {residential.Category === 'Residence' && residential.FloorArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Floor Area is required</label>
                                }
                                {residential.Category === 'Unit' && residential.FloorArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Floor Area is required</label>
                                }
                                {residential.Category === 'Townhouse' && residential.FloorArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Floor Area is required</label>
                                }
                                {residential.Category === 'Home and Income' && residential.FloorArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Floor Area is required</label>
                                }
                                {residential.Category === 'Apartment' && residential.FloorArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Floor Area is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="LandAreaInput">Land Area</label>
                                <div className="input-group">
                                    <input type="number" className="form-control" id="LandArea" value={residential.LandArea || 0} onChange={(e) => handle(e)} />
                                    <select className="form-control" id="FloorAreaSelect" value={"1"}>
                                        <option className="form-control" value="1"><sub>m</sub>2</option>
                                        <option className="form-control" value="2">Ha</option>
                                    </select>
                                </div>
                                {residential.LandArea === '0' &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is 0</label>}<br />
                                {residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is null</label>}<br />
                                {parseInt(residential.LandArea) < 100 &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is small</label>}<br />
                                {parseInt(residential.LandArea) > 10000 &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area exceeds 10000m<sup>2</sup></label>}<br />

                                {residential.Category === 'Residential Section' && residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>
                                }
                                {residential.Category === 'Residence' && residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>
                                }
                                {residential.Category === 'Unit' && residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>
                                }
                                {residential.Category === 'Townhouse' && residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>
                                }
                                {residential.Category === 'Home and Income' && residential.LandArea === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Land Area is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="BedroomsInput">No. of Bedrooms</label>
                                <input type="number" className="form-control" id="Bedrooms" value={residential.Bedrooms || 0} onChange={(e) => handle(e)} />
                                {residential.Category === 'Apartment' && residential.Bedrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bedrooms is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="BathroomsInput">No. of Bathrooms</label>
                                <input type="number" className="form-control" id="Bathrooms" value={residential.Bathrooms || 0} onChange={(e) => handle(e)} />
                                {residential.Category === 'Residence' && residential.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                                {residential.Category === 'Unit' && residential.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                                {residential.Category === 'Townhouse' && residential.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                                {residential.Category === 'Home and Income' && residential.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                                {residential.Category === 'Apartment' && residential.Bathrooms === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>No.of Bathrooms is required</label>
                                }
                            </div>
                            <div className="form-group">
                                <label htmlFor="ParkingTotalInput">Total Parking</label>
                                <input type="number" className="form-control" id="ParkingTotal" value={residential.ParkingTotal || 0} onChange={(e) => handle(e)} />
                                {residential.Category === 'Residence' && residential.ParkingTotal === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Total Parking is required</label>
                                }
                                {residential.Category === 'Unit' && residential.ParkingTotal === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Total Parking is required</label>
                                }
                                {residential.Category === 'Townhouse' && residential.ParkingTotal === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Total Parking is required</label>
                                }
                                {residential.Category === 'Home and Income' && residential.ParkingTotal === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Total Parking is required</label>
                                }
                                {residential.Category === 'Apartment' && residential.ParkingTotal === null &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Total Parking is required</label>
                                }
                            </div>
                            <div className="form-group checkbox-container">

                                <label htmlFor="IsNewDwellingInput">New Dwelling</label>
                                <Checkbox id="IsNewDwelling" name="IsNewDwelling" checked={residential.IsNewDwelling} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsSaleAsIsInput">Sale As Is<OverlayTrigger placement="top"
                                    overlay={renderTooltip_saleasis}><sup>?</sup></OverlayTrigger>
                                </label>
                                <Checkbox id="IsSaleAsIs" name="IsSaleAsIs" checked={residential.IsSaleAsIs} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsOwnerOccupiedInput">Owner is Occupier</label>
                                <Checkbox id="IsOwnerOccupied" name="IsOwnerOccupied" checked={residential.IsOwnerOccupied} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsFirstHomeBuyerInput">First Home Buyer</label>
                                <Checkbox id="IsFirstHomeBuyer" name="IsFirstHomeBuyer" checked={residential.IsFirstHomeBuyer} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsMortgageSaleInput">Mortgage Sale</label>
                                <Checkbox id="IsMortgageSale" name="IsMortgageSale" checked={residential.IsMortgageSale} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsMortgageSaleInput">Investment or Rental</label>
                                <Checkbox id="IsInvestmentOrRental" name="IsInvestmentOrRental" checked={residential.IsInvestmentOrRental} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="HeldInput">Hold Sale<OverlayTrigger placement="top" overlay={renderTooltip_holdsale}><sup>?</sup></OverlayTrigger>
                                </label>
                                <Checkbox id="Held" name="Held" checked={residential.Held} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="SuppressedInput">Supress Sale<OverlayTrigger placement="top" overlay={renderTooltip_supresssale}><sup>?</sup></OverlayTrigger>
                                </label>
                                <Checkbox id="Suppressed" name="Suppressed" checked={residential.Suppressed} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;


                                <label htmlFor="DepositSaleOnlyInput">Deposit Sale Only</label>
                                <Checkbox id="DepositSaleOnly" name="DepositSaleOnly" checked={residential.DepositSaleOnly} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="HasPoolInput">Has Pool</label>
                                <Checkbox id="HasPool" name="HasPool" checked={residential.HasPool} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />&nbsp;&nbsp;&nbsp;&nbsp;

                                <label htmlFor="IsGstExemptInput">GST Exempt</label>
                                <Checkbox id="IsGstExempt" name="IsGstExempt" checked={residential.IsGstExempt} onChange={(e) => checkboxHandle(e)}
                                    sx={{
                                        color: '#563abe',
                                        '&.Mui-checked': {
                                            color: '#563abe',
                                        },
                                        padding: 0,
                                    }}
                                />

                            </div>
                            <div className="form-group">
                                {/*Additional Information*/}
                                <label className="labelClass"><h4>Additional Information</h4></label>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SaleMethodInput">Sale Method <span style={{ color: 'red' }}>*</span></label>
                                    <div id="SelectStyle">
                                        <select name="SaleMethod" className="form-control" id="SaleMethod" value={residential.SaleMethod || null} onChange={(e) => handle(e)} required>
                                            <option className="form-control"></option>
                                            <option className="form-control">P - Private Treaty(Neg.)</option>
                                            <option className="form-control">A - Auction</option>
                                            <option className="form-control">T - Tender</option>
                                        </select>
                                    </div>
                                    {(residential.SaleMethod === null || residential.SaleMethod === '') &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                    }
                                    {/*<label as="label" className="required" style={{ color: 'red' }}>Sale Method is required</label>*/}
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ListPriceInput">List Price</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="ListPrice" value={residential.ListPrice} onChange={(e) => handle(e)} />
                                    </div>
                                    {(residential.SaleMethod === 'P - Private Treaty(Neg.)' && residential.ListPrice === '') &&
                                       <label as="label" className="required" style={{ color: 'red' }}>List Price is required</label>
                                      /*<div style={{ color: 'red' }}>{error}</div>*/
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SalePriceInput">Sale Price <span style={{ color: 'red' }}>*</span></label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="SalePrice" value={residential.SalePrice} onChange={(e) => handle(e)} required />
                                    </div>
                                    {(residential.SalePrice === null || residential.SalePrice === '') &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                    }
                                    {/*<label as="label" className="required" style={{ color: 'red' }}>SalePrice is required</label>*/}
                                </div>
                                {residential.SalePrice <= (residential.Valuation * 0.1) &&
                                    <label as="label" className="required" style={{ color: 'red' }}>Sale Price is 10% or more below valuation of {residential.Valuation}</label>}
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ListDateInput">List Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_listdate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" placeholder="Enter a date or click the icon to open the datepicker" class="form-control" id="ListDate"
                                    value={residential.ListDate || null} onChange={(e) => handle(e)} required />
                                    {(residential.ListDate === null || residential.ListDate === '') &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                    }
                                    {/*<label as="label" className="required" style={{ color: 'red' }}>ListDate is required</label>*/}
                                    {residential.ListDate > residential.AgreementDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date cannot be greater than Agreement Date</label>
                                    }
                                    {residential.ListDate > residential.UnconditionalDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date cannot be greater than Unconditional Date</label>
                                    }
                                    {residential.ListDate && residential.AgreementDate &&
                                        listDateObj.getFullYear() + 5 < agreementDateObj.getFullYear() &&
                                        <label as="label" className="required" style={{ color: 'red' }}>List Date is greater than 5 years from Agreement Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="AgreementDateInput">Agreement Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_agreementdate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="form-control" id="AgreementDate" value={residential.AgreementDate || null} onChange={(e) => handle(e)} required />
                                    {(residential.AgreementDate === null || residential.AgreementDate === '') &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                    }
                                    {/*<label as="label" className="required" style={{ color: 'red' }}>Agreement Date is required</label>*/}
                                    {(residential.AgreementDate > residential.UnconditionalDate) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Agreement Date cannot be greater than Unconditional Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="UnconditionalDateInput">Unconditional Date <OverlayTrigger
                                        placement="top" overlay={renderTooltip_unconditionaldate}><sup>?</sup></OverlayTrigger><span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input type="date" class="form-control" id="UnconditionalDate" value={residential.UnconditionalDate || null} onChange={(e) => handle(e)} required />
                                    {(residential.UnconditionalDate === null || residential.UnconditionalDate === '') &&
                                        <div style={{ color: 'red' }}>{error}</div>
                                    }
                                    {/*<label as="label" className="required" style={{ color: 'red' }}>Unconditional Date is required</label>*/}
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="SettlementDateInput">Settlement Date</label>
                                    <input type="date" class="form-control" id="SettlementDate" value={residential.SettlementDate} onChange={(e) => handle(e)} />
                                    {residential.SettlementDate < residential.UnconditionalDate &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Settlement Date cannot be lesser than Unconditional Date</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationInput">Current Valuation</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="Valuation" value={residential.Valuation || null} onChange={(e) => handle(e)} />
                                    </div>
                                    {(residential.Valuation && residential.LandValue && residential.ValuationImprovement)!==0 && residential.Valuation !== (residential.LandValue + residential.ValuationImprovement) &&
                                        (<label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>)
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationDateInput">Valuation Date</label>
                                    <input type="date" class="form-control" id="ValuationDate" value={residential.ValuationDate || null} onChange={(e) => handle(e)} />
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="LandValueInput">Land Value</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="LandValue" value={residential.LandValue || null} onChange={(e) => handle(e)} />
                                    </div>
                                    {(residential.Valuation && residential.LandValue && residential.ValuationImprovement)!==0 && residential.Valuation !== (residential.LandValue + residential.ValuationImprovement) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>
                                    }
                                </div>
                                <div className="form-group">
                                    <label className="labelClass" htmlFor="ValuationImprovementInput">Improvement Value</label>
                                    <div className="input-group">
                                        <span class="input-group-text" id="dollar-sign" >
                                            <i class="bi bi-currency-dollar iconStyles"></i>
                                        </span>
                                        <input type="number" class="form-control" id="ValuationImprovement" value={residential.ValuationImprovement || null} onChange={(e) => handle(e)} />
                                    </div>
                                    {(residential.Valuation && residential.LandValue && residential.ValuationImprovement)!==0 && residential.Valuation !== (residential.LandValue + residential.ValuationImprovement) &&
                                        <label as="label" className="required" style={{ color: 'red' }}>Sum of Improvement and Land Value needs to equal Current Valuation</label>
                                    }
                                </div>
                                <div id="FileReturnButton">
                                    <input type="submit" value="Update Return" onClick={SubmitUpdate}
                                        className="btn FileReturnButtonClass" />
                                </div>
                            </div>
                            {/*{message === true && <DisplaySavedMessage />} */}
                            {message && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{message}</div>}
                            {validationError && <div style={{ color: errorMessage ? 'red' : 'green', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>{validationError}</div>}
                            {/* Loading overlay */}
                            {loading && (
                                <div className="overlay">
                                    <div className="spinner"></div>
                                    <p style={{ color: 'black', textAlign: 'center', fontWeight: 'bold', fontSize: '20px' }}>Processing... Please wait</p>
                                </div>
                            )}
                          </form>
                    </div>                    
                </>
            }

        </>

    );

}

